import cx from 'classnames'
import React from 'react'
import UICard from 'shared-web/src/components/Card'
import styles from './styles.styl'

const Card = ({ className, ...rest }) => (
  <UICard className={cx(styles.Card, className)} {...rest} />
)

export default Card



// WEBPACK FOOTER //
// ./src/scripts/components/shared/Card/index.js